import { Control } from './control';

export class ClickableCard extends Control {
    private link: HTMLAnchorElement;
    private card: HTMLElement;
    private down: number = 0;
    private up: number = 0;

    public static selector: string = ".cards-link li";

    constructor(containerElement: Element) {
        super(containerElement);
        
        // elements
        this.link = this.container.querySelector("a") as HTMLAnchorElement;
        this.card = this.container as HTMLElement;

        // events
        this.card.addEventListener("mousedown", () => this.onCardMousedown());
        this.card.addEventListener("mouseup", event => this.onCardMouseup(event));
        this.card.style.cursor = "pointer";
    }

    private onCardMousedown(): void {
        this.down = Date.now();
    }
    
    private onCardMouseup(event: MouseEvent): void {
        this.up = Date.now();
        if (event.button === 0 && (this.up - this.down) < 200) {
            this.link.click();
        }
    }
}
